"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("../../../../context");
const Icon_1 = tslib_1.__importDefault(require("../../../../ui-lib/Buttons/Icon"));
const Icons_1 = tslib_1.__importDefault(require("../../../../ui-lib/Icons"));
const ErrorBoundary_1 = require("../../../ErrorBoundary");
const MicrophoneButton = (0, mobx_react_lite_1.observer)(({ onClick, classes = {
    root: {},
    icon: {},
}, icon: ProvidedIcon, screenReaderText, label = "Toggle mute", active, ...props }) => {
    /**
     * Component Name (for error msg)
     */
    const componentName = "<MicrophoneButton/>";
    /**
     * Access EncoderUiContext & destructure API state
     */
    const ctx = (0, react_1.useContext)(context_1.EncoderUiContext);
    /**
     * Throw error (and trigger ErrorBoundary) if store is undefined.
     * */
    (0, ErrorBoundary_1.useUndefinedStoreError)((ctx === null || ctx === void 0 ? void 0 : ctx.mediaStreamController) != null, componentName);
    const toggleMic = () => {
        ctx.mediaStreamController.audioMuted = !ctx.mediaStreamController.audioMuted;
    };
    /**
     * handleClick function wrapped in global Error handler (to trigger ErrorBoundary).
     * */
    const handleClick = onClick || (0, ErrorBoundary_1.useUIEventError)(toggleMic, componentName);
    const activeState = active !== null && active !== void 0 ? active : !ctx.mediaStreamController.audioMuted;
    const proppedIcon = activeState ? (react_1.default.createElement(Icons_1.default, { title: label, iconName: "microphone", classes: classes === null || classes === void 0 ? void 0 : classes.icon })) : (react_1.default.createElement(Icons_1.default, { title: label, iconName: "microphoneoff", classes: classes === null || classes === void 0 ? void 0 : classes.icon }));
    return (react_1.default.createElement(Icon_1.default, { active: activeState, classes: classes, "data-selenium": "mic-toggle-button", icon: ProvidedIcon || proppedIcon, onClick: handleClick, label: label, disabled: ctx.mediaStreamController.audioDeviceId == null || ctx.mediaStreamController.audioDisabled === "placeholder", ...props }, screenReaderText !== null && screenReaderText !== void 0 ? screenReaderText : `Click to ${active ? "Stop" : "Start"} Audio Stream`));
});
function MicrophoneButtonWithErrorBoundary({ icon: ProvidedIcon, classes, label = "Toggle mute", screenReaderText, style = {}, ...props }) {
    const icon = ProvidedIcon || react_1.default.createElement(Icons_1.default, { iconName: "microphoneoff", classes: classes === null || classes === void 0 ? void 0 : classes.icon });
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => (react_1.default.createElement(Icon_1.default, { "data-selenium": "mic-toggle-button", disabled: true, label: label, icon: icon, classes: classes, onClick: undefined, active: false, ...props }, screenReaderText !== null && screenReaderText !== void 0 ? screenReaderText : "Click to Start Audio Stream")) },
        react_1.default.createElement(MicrophoneButton, { classes: classes, icon: ProvidedIcon, label: label, screenReaderText: screenReaderText, style: style, ...props })));
}
exports.default = MicrophoneButtonWithErrorBoundary;
//# sourceMappingURL=Microphone.js.map